import React from 'react';
import { Elements } from 'react-stripe-elements';
import StripeForm from './StripeForm';

const Stripe = () => {
  return (
    <div>
      <Elements>
        <StripeForm />
      </Elements>
    </div>
  );
};

export default Stripe;
